import { button, buttonIcon, element, heading } from "@groundspark/browser-ui";

/** Asks before a destructive action; aborting the signal cancels the dialog. */
export function confirmDeletion(
  id: string,
  title: string,
  description: string,
  confirmLabel: string,
  signal: AbortSignal,
): Promise<boolean> {
  const dialog = element("dialog", "dialog");
  const titleElement = heading(2, title, "dialog__title");
  titleElement.id = `${id}-title`;
  const descriptionElement = element("p", "dialog__description", description);
  descriptionElement.id = `${id}-description`;
  dialog.setAttribute("aria-labelledby", titleElement.id);
  dialog.setAttribute("aria-describedby", descriptionElement.id);
  const cancel = button("Cancel", "button button--white", () => dialog.close("cancel"));
  cancel.autofocus = true;
  const confirm = button(confirmLabel, "button button--danger", () => dialog.close("delete"));
  confirm.prepend(buttonIcon("delete"));
  dialog.append(
    element("header", "dialog__header", titleElement),
    descriptionElement,
    element("div", "dialog__actions", cancel, confirm),
  );
  const previousFocus = document.activeElement;
  return new Promise((resolve) => {
    const abort = (): void => dialog.close("cancel");
    signal.addEventListener("abort", abort, { once: true });
    dialog.addEventListener("cancel", (event) => {
      event.preventDefault();
      dialog.close("cancel");
    });
    dialog.addEventListener(
      "close",
      () => {
        signal.removeEventListener("abort", abort);
        dialog.remove();
        if (
          !signal.aborted &&
          previousFocus instanceof HTMLElement &&
          previousFocus.isConnected
        )
          previousFocus.focus({ preventScroll: true });
        resolve(!signal.aborted && dialog.returnValue === "delete");
      },
      { once: true },
    );
    document.body.append(dialog);
    dialog.showModal();
    cancel.focus();
  });
}
